import { Component } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-report-export-png',
  templateUrl: './report-export-png.component.html',
  styleUrl: './report-export-png.component.scss',
  standalone: false,
})
export class ReportExportPngComponent extends BaseComponent {
  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }
  public onExportPng(): void {
    this.toolbarEventManagerHelper.ReportToolbarExportAsPng = true;
  }
}
